/**
 * Defines an exact translation record while preserving each value as a string literal.
 *
 * The curried form lets callers provide the expected record type while TypeScript infers
 * the translation object with a `const` type parameter. Intersecting the inferred object
 * with `Expected` reports missing properties, while unexpected properties are mapped to
 * a descriptive error type. Unlike `satisfies`, this produces a diagnostic for which VS
 * Code offers "Add missing properties", while the preserved literals remain available to
 * compile-time validators.
 */
export const defineTranslations =
  <Expected extends Record<string, string>>() =>
  <const Translations extends Record<string, string>>(
    translations: Expected & {
      [Key in keyof Translations]: Key extends keyof Expected
        ? Translations[Key]
        : Key extends string
          ? `Unknown translation key "${Key}"`
          : never
    },
  ) =>
    translations as Translations
